import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from "@/shared-components/icons/components/public/XIcon";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";
import Text from "@/shared-components/text/components/Text";

import "./styles/PopUpConfirmDeleteDraft.css";

const PopUpConfirmDeleteDraft = ({
  onConfirm,
  open,
  close,
  draftName,
  title,
}) => {  
  const t = useTranslations('common.profile.popups.confirm_delete_draft');
  const resolvedDraftName = draftName || t('defaults.this_draft');
  const resolvedTitle = title || t('defaults.delete_draft');

  return (
    <GenericPopup
      open={open}
      className="popup-confirm-draft-delete-container__popup"
      opacity
    >
      <div className="popup-confirm-draft-delete-container relative">
        <div className="popup-confirm-draft-delete-header">
          <Text className="popup-confirm-draft-delete-header-text">
            {resolvedTitle}
          </Text>
          <XIcon className="popup-confirm-draft-delete-close" onClick={close} />
        </div>

        <Text className="popup-confirm-draft-delete-text">
          {t('message_prefix')}
          <span className="popup-confirm-draft-delete_draftname_theme">{resolvedDraftName}</span>
          {t('message_suffix')}
        </Text>
      </div>
      <div className="popup-confirm-draft-delete_buttons">
        <ContinueButton 
          onClick={(event) => {
            onConfirm(event);
            close();
          }} 
          className="font-size-medium"
        >
          {t('confirm_button')}
        </ContinueButton>
      </div>
    </GenericPopup>
  );
};

export default PopUpConfirmDeleteDraft;
